export type SITE_IDS = "main_sv" | "main_en";

const sites: Record<string, SITE_IDS> = {
  "dev.fantasy.allsvenskan.se": "main_sv",
  "en.dev.fantasy.allsvenskan.se": "main_en",
  "allsvenskan.staging.ismgames.com": "main_sv",
  "en.allsvenskan.staging.ismgames.com": "main_en",
  "fantasy.allsvenskan.se": "main_sv",
  "en.fantasy.allsvenskan.se": "main_en",
};

export const getSite = () => sites[window.location.hostname] || "";
